import { __ } from '@wordpress/i18n';

const getFormattedLabel = (status) => {
    switch (status) {
        case 'to_work':
            return __('In Lavorazione', 'htr');

        default:
            return status;
    }
}

export default getFormattedLabel;